import React from "react";


import Australiafaq from "@/pages/australiafaq";
import { FaCheckCircle } from "react-icons/fa";
import Contacts from "@/pages/contacts";

function Australia() {
  // const iconBoxes = [
  //   {
  //     icon: "multi.png",
  //     title: "Skilled Migration Visa",
  //     description:
  //       "For qualified professionals nominated by Australian states, territories, or eligible relatives for immigration.",
  //     href: "/skilled-migration-visa",
  //   },
  //   {
  //     icon: "investorr.png",
  //     title: "Investor Visa",
  //     description:
  //       "Australia's expanding economy offers a prime environment for investment and economic opportunities.",
  //     href: "/investor-visa",
  //   },
  //   {
  //     icon: "student.png",
  //     title: "Student Visa",
  //     description:
  //       "Australia is a leading destination for higher education, offering world-class facilities and abundant opportunities.",
  //     href: "/student-visa",
  //   },
  //   {
  //     icon: "visit.png",
  //     title: "Visitor Visa",
  //     description:
  //       "Ideal for tourism, family visits, cultural exchanges, or short business trips to explore Australia.",
  //     href: "/visit-visa",
  //   },
  // ];


  const SectionIconBoxes = () => {
    return (
      <>
        <div className="h-98 relative w-full ">
          <img
            src="australiaa.jpg" // Replace with the correct path to your image
            alt="Canada Immigrations"
            className="h-full w-full object-cover"
          />
          <div className="absolute bottom-5 left-20 md:text-4xl text-xl font-bold text-white drop-shadow-md">
            Australia
          </div>
        </div>

        <div className="w-full md:w-full xl:mt-32 lg:mt-32 md:mt-20 mt-32 px-5 md:px-20">
          <p className="text-2xl text-[#011473] md:text-6xl font-bold mb-5 text-center">
            Popular Visa Options
          </p>

          <div className="container mx-auto mb-10 mt-14">
            <div className="grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-4 gap-6">
              {/* Skilled Migration Visa */}
              <div className="flex flex-col items-center text-center p-2 border shadow-md relative group hover:cursor-pointer transform transition-transform duration-300 rounded-xl hover:scale-105 hover:shadow-xl h-64">
                <img
                  src="/img.jpg"
                  alt="Skilled Migration Visa"
                  className="w-40 h-40 mb-4 group-hover:opacity-0 transition-opacity duration-300"
                />
                <h2 className="text-xl md:text-xl text-[#011473] font-medium group-hover:opacity-0 transition-opacity duration-300">
                  Skilled Migration Visa
                </h2>
                <div className="absolute flex flex-col items-center justify-center inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-lg text-center mb-4">
                    For qualified professionals nominated by Australian states, territories, or eligible relatives for immigration.
                  </p>
                  <a href="/australia-skilled-migration-visa">
                    <button className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors duration-300">
                      Read More
                    </button>
                  </a>
                </div>
              </div>

              {/* Investor Visa */}
              <div className="flex flex-col items-center text-center p-8 border shadow-md relative group hover:cursor-pointer transform transition-transform duration-300 rounded-xl hover:scale-105 hover:shadow-xl h-64">
                <img
                  src="/investor.jpg"
                  alt="Investor Visa"
                  className="w-60 h-96 mb-4 group-hover:opacity-0 transition-opacity duration-300"
                />
                <h2 className="text-xl md:text-xl text-[#011473] font-medium group-hover:opacity-0 transition-opacity duration-300">
                  Investor Visa
                </h2>
                <div className="absolute flex flex-col items-center justify-center inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-lg text-center mb-4">
                    Australia's expanding economy offers a prime environment for investment and economic opportunities.
                  </p>
                  <a href="/australia-investor-visa">
                    <button className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors duration-300">
                      Read More
                    </button>
                  </a>
                </div>
              </div>

              {/* Student Visa */}
              <div className="flex flex-col items-center text-center p-8 border shadow-md relative group hover:cursor-pointer transform transition-transform duration-300 rounded-xl hover:scale-105 hover:shadow-xl h-64">
                <img
                  src="/student.jpg"
                  alt="Student Visa"
                  className="w-40 h-40 mb-4 group-hover:opacity-0 transition-opacity duration-300"
                />
                <h2 className="text-xl md:text-xl text-[#011473] font-medium group-hover:opacity-0 transition-opacity duration-300">
                  Student Visa
                </h2>
                <div className="absolute flex flex-col items-center justify-center inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-lg text-center mb-4">
                    Australia is a leading destination for higher education, offering world-class facilities and abundant opportunities.
                  </p>
                  <a href="/australia-student-visa">
                    <button className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors duration-300">
                      Read More
                    </button>
                  </a>
                </div>
              </div>

              {/* Visit Visa */}
              <div className="flex flex-col items-center text-center p-2 border shadow-md relative group hover:cursor-pointer transform transition-transform duration-300 rounded-xl hover:scale-105 hover:shadow-xl h-64">
                <img
                  src="/visit.jpg"
                  alt="Visit Visa"
                  className="w-40 h-40 mb-4 group-hover:opacity-0 transition-opacity duration-300"
                />
                <h2 className="text-xl md:text-xl text-[#011473] font-medium group-hover:opacity-0 transition-opacity duration-300">
                  Visit Visa
                </h2>
                <div className="absolute flex flex-col items-center justify-center inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-lg text-center mb-4">
                    Ideal for tourism, family visits, cultural exchanges, or short business trips to explore Australia.
                  </p>
                  <a href="/australia-visit-visa">
                    <button className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors duration-300">
                      Read More
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <Canadaimport /> */}

        <section className="bg-white px-4 py-8">
          <div className="container mx-auto">
            {/* Section Heading */}
            <h2 className="mb-6 text-2xl font-bold text-[#011473] md:text-3xl">
              How Visa World Can Help You
            </h2>

            {/* List Items */}
            <ul className="space-y-4">
              <li className="flex items-start">
                <FaCheckCircle className="mt-1 h-6 w-6 flex-shrink-0 text-blue-500" />
                <p className="ml-4 text-gray-700">
                  Our team of experts will collaborate closely with you to understand your objectives and provide personalized immigration services tailored to your specific needs and legal requirements.
                </p>
              </li>

              <li className="flex items-start">
                <FaCheckCircle className="mt-1 h-6 w-6 flex-shrink-0 text-blue-500" />
                <p className="ml-4 text-gray-700">
                  Whether you're looking to migrate to countries like the UK, Canada, or Australia, we connect you with licensed consultants to ensure a seamless and successful process.
                </p>
              </li>

              <li className="flex items-start">
                <FaCheckCircle className="mt-1 h-6 w-6 flex-shrink-0 text-blue-500" />
                <p className="ml-4 text-gray-700">
                  We offer comprehensive services across multiple visa categories including Skilled Migration, Business Immigration, Study Abroad Programs and more, ensuring you're guided every step of the way.
                </p>
              </li>

              <li className="flex items-start">
                <FaCheckCircle className="mt-1 h-6 w-6 flex-shrink-0 text-blue-500" />
                <p className="ml-4 text-gray-700">
                  With a proven success rate of 98%, Visa World has helped thousands of clients achieve their immigration goals, making us a trusted partner in your journey.
                </p>
              </li>
            </ul>
          </div>
        </section>

        

        {/* Contact Section */}
        <div className="py-12"></div>

        <Australiafaq />
        <Contacts />
      </>
    );
  };

  return <SectionIconBoxes />;
}

export default Australia;
